import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';


class AboneSicilListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AboneSicilListe";
    super(baseUrl);
  }


  getAboneSicilListe(sicilKodu: number,aboneNo?: number){
    
        var request= new AboneSicilRequest(sicilKodu,aboneNo);
    return this.post("", request, false);
   
  }

}
export default new AboneSicilListeAPI();
class AboneSicilRequest {
  public aboneNo?: number;
  public sicilKodu: number;
  constructor(sicilKodu: number,aboneNo?: number) {
   
      this.aboneNo = aboneNo;
      this.sicilKodu = sicilKodu;

  }
}
export { AboneSicilRequest };